import React, { useEffect } from "react";

function getRedirectUrl(currentUrl) {
    const { origin, pathname } = new URL(currentUrl);
    
    const urlMap = {
        "/contactus": "https://www.flowcart.ai/book-demo",
        "/bookdemo": "https://www.flowcart.ai/book-demo",
        "/customer-stories": "https://www.flowcart.ai/case-study",
        "/customer-stories/darling": "https://www.flowcart.ai/case-study/darling",
        "/customer-stories/uncover": "https://www.flowcart.ai/case-study/uncover",
        "/partnerships": "https://www.flowcart.ai/partnership",
        "/pricing": "https://www.flowcart.ai/pricing",
        "/privacy_policy": "https://www.flowcart.ai/privacy-policy",
        "/tnc": "https://www.flowcart.ai/tnc",
    };
    return urlMap[pathname] || "https://www.flowcart.ai/";
}

const RedirectToFlowCart = () => {

    useEffect(() => {
        const timer = setTimeout(() => {
            window.location.href = getRedirectUrl(window.location.href);
        }, 1800);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="tw-bg-white tw-text-white tw-h-screen tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-2xl tw-overflow-hidden">
        <span className="animate-fadeIn tw-flex tw-flex-col tw-items-center">
            <a href="https://www.flowcart.ai/">
            <img
                src="https://cdn.prod.website-files.com/67e15bdb13f884fd42a99dca/687e586997cd69fd3dc96ca9_NavBar%20logo%20(1).svg"
                alt="FlowCart Logo"
                className="tw-mb-4 max-sm:tw-max-w-[300px] tw-h-auto"
            />
            </a>
        </span>
        <style>
            {`
            @keyframes fadeIn {
                0% { opacity: 0; transform: scale(0.9);}
                100% { opacity: 1; transform: scale(1.1);}
            }
            .animate-fadeIn {
                animation: fadeIn 2.5s ease-in-out;
            }
            `}
        </style>
        </div>
    );
};

export default RedirectToFlowCart;
